/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 2v5h3v5h-2V9h-1v13h-2v-2H7v2H5V9H4v3H2V7h3V2zm-2 12H7v4h10zm-7 1v2H8v-2zm6 0v2h-2v-2zm1-7H7v4h10zm0-4H7v2h10z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBus as Bus };
